import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubstitutionAppUserForm } from '../forms/SubstitutionAppUserForm';

type SubstitutionAppUserModalProps = {
  isOpen: boolean;
  onClose: () => void;
  monitorUser?: {
    username: string;
    school: string;
    monitorEnabled: boolean;
    pushEnabled: boolean;
    allowPasswordReset: boolean;
  };
};

export const SubstitutionAppUserModal = ({ isOpen, onClose, monitorUser }: SubstitutionAppUserModalProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal title={t('substitutions.app.editMonitorUser')} isOpen={isOpen} onRequestClose={onClose} loading={loading}>
      <SubstitutionAppUserForm onClose={onClose} onLoad={setLoading} initialValues={monitorUser} />
    </Modal>
  );
};
